import { render, staticRenderFns } from "./SelffetchLog.vue?vue&type=template&id=b30292a4&scoped=true"
import script from "./SelffetchLog.vue?vue&type=script&lang=js"
export * from "./SelffetchLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b30292a4",
  null
  
)

export default component.exports